// @greenlight-spec: 16-api-conventions.md
import { APP_SLUG_REGEX, GITHUB_ORG_LOGIN_REGEX, ORG_SLUG_REGEX } from '../constants/index.js';
export { APP_SLUG_REGEX, GITHUB_ORG_LOGIN_REGEX, ORG_SLUG_REGEX };
export const isValidAppSlug = (value) => APP_SLUG_REGEX.test(value);
export const isValidOrgSlug = (value) => ORG_SLUG_REGEX.test(value);
export const isValidGithubOrgLogin = (value) => GITHUB_ORG_LOGIN_REGEX.test(value);
/**
 * The slug an org display name derives from: accents folded, every run of
 * non-alphanumerics collapsed to one hyphen, leading digits dropped so the
 * result can start with a letter, and capped at the 32 characters
 * `ORG_SLUG_REGEX` allows. Returns "" when nothing valid survives — the caller
 * reports that at the field rather than sending it to the server.
 */
export function orgSlugFromName(name) {
    const candidate = name
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^[-0-9]+/, '')
        .slice(0, 32)
        .replace(/-+$/, '');
    return isValidOrgSlug(candidate) ? candidate : '';
}
//# sourceMappingURL=slug.js.map